interface SsopsLogoProps {
  /** Render only the two-tone "O" mark, without the wordmark (e.g. collapsed nav). */
  markOnly?: boolean
  /** Mark height in px; the wordmark scales relative to it. */
  size?: number
}

/**
 * SSOps brand lockup — the shared "O" drawn as a two-tone lifecycle loop
 * (cyan "sign-in" arc over an indigo "operations" arc), with the cyan "O"
 * echoed in the wordmark. Tuned for the always-dark sidebar: indigo-light
 * lower arc (#7C84F6) and white wordmark for contrast. Source of truth for
 * the art is docs/brand/ssops-mark.svg / ssops-logo-dark.svg.
 */
export function SsopsLogo({ markOnly = false, size = 28 }: SsopsLogoProps) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        role="img"
        aria-label="SSOps"
      >
        <title>SSOps</title>
        {/* cyan top arc — the "sign-in" moment */}
        <path
          d="M 10.75 26.31 A 22 22 0 0 1 53.25 26.31"
          fill="none"
          stroke="#1AC8DA"
          strokeWidth="7"
          strokeLinecap="round"
        />
        {/* indigo-light bottom arc — ongoing operations (dark-bg contrast) */}
        <path
          d="M 53.25 37.69 A 22 22 0 0 1 10.75 37.69"
          fill="none"
          stroke="#7C84F6"
          strokeWidth="7"
          strokeLinecap="round"
        />
      </svg>
      {!markOnly && (
        <span
          style={{
            fontFamily: "'Space Grotesk','Segoe UI',system-ui,-apple-system,sans-serif",
            fontWeight: 700,
            fontSize: size * 0.8,
            letterSpacing: '-0.5px',
            lineHeight: 1,
            color: '#ffffff',
          }}
        >
          SS<span style={{ color: '#1AC8DA' }}>O</span>ps
        </span>
      )}
    </span>
  )
}
